import { render, staticRenderFns } from "./datatable-result-row.vue?vue&type=template&id=db24ab6c&scoped=true&"
import script from "./datatable-result-row.vue?vue&type=script&lang=ts&"
export * from "./datatable-result-row.vue?vue&type=script&lang=ts&"
import style0 from "./datatable-result-row.vue?vue&type=style&index=0&id=db24ab6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db24ab6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
